import { PAGINGATION_DEFAULT } from '@const/pagination'

const initInvoiceList: TInvoiceManagementDetail.TState['invoiceList'] = {
  data: [],
  ...PAGINGATION_DEFAULT
}

export const initialState: TInvoiceManagementDetail.TState = {
  invoiceList: initInvoiceList,
  invoiceListDownload: [],
  isFetchingInvoiceList: true,
  showModalChangeStatus: false,
  showModalDetail: false,
  isLoading: false,
  tempData: {},
  invoiceHistoryDetail: {
  },
  isFetchingInvoiceDetail: true
}
